import MuiAlert, { AlertColor } from "@mui/lab/Alert";
import MuiAlertTitle from "@mui/lab/AlertTitle";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState } from "react";
import {
  AnnouncementSeverity,
  GlobalAnnouncementModel,
} from "../../../types/GlobalAnnouncementModel";
import MultilineText from "../MultilineText";

export function GlobalAnnouncement(model: GlobalAnnouncementModel | null) {
  const styles = useStyles();
  let [isClosed, setClosed] = useState<boolean>(false);
  const { severity, title, message, isActive } = model ?? {};

  //reset closed status to false if announcementMessage changed
  useEffect(() => {
    setClosed(false);
  }, [message, title, severity, isActive]);

  return (
    <>
      {isActive === true && isClosed === false && (
        <MuiAlert
          classes={styles}
          elevation={0}
          variant="filled"
          severity={
            severity !== undefined
              ? (AnnouncementSeverity[severity] as unknown as AlertColor)
              : undefined
          }
          onClose={() => setClosed(true)}
        >
          <MuiAlertTitle>{title}</MuiAlertTitle>
          <MultilineText text={message} />
        </MuiAlert>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    zIndex: 1,
    left: theme.spacing(1),
    bottom: theme.spacing(6),
  },
}));
